<template>
  <div class="vm-container login-container">
    <div class="auth__content login__box">
      <h1
        class="login__box__header"
        v-html="$t('ManageIdentity.Views.Account.Login.Headline')"
      />
      <div
        class="login__box__description"
        v-html="$t('ManageIdentity.Views.Account.Login.HeadlineClaim')"
      />
      <br />
      <b-alert
        :show="dismissCountDownInvalid"
        dismissible
        variant="danger"
        @dismissed="dismissCountDownInvalid = 0"
        @dismiss-count-down="countDownChangedInvalid"
      >
        <div v-html="alertData" />
      </b-alert>
      <b-alert
        :show="dismissCountDownLockout"
        dismissible
        variant="danger"
        @dismissed="dismissCountDownLockout = 0"
        @dismiss-count-down="countDownChangedLockout"
      >
        <h1 v-html="$t('ManageIdentity.Views.Account.Lockout.Headline')" />
        <span v-html="$t('ManageIdentity.Views.Account.Lockout.SubHeadline')" />
      </b-alert>
      <b-alert
        :show="dismissCountDownInvalidLogin"
        dismissible
        variant="danger"
        @dismissed="dismissCountDownInvalidLogin = 0"
        @dismiss-count-down="countDownChangedInvalidLogin"
      >
        <h1
          v-html="$t('ManageIdentity.SharedResources.StatusMessageWarning')"
        />
        <span
          v-html="
            $t(
              'ManageIdentity.Controllers.AccountController.Invalidloginattempt'
            )
          "
        />
      </b-alert>
      <b-alert
        :show="showEmailAlert && !emailValidation"
        dismissible
        variant="danger"
      >
        <span v-html="$t('general.InvalidEmail_txt')" />
      </b-alert>
      <br />
      <b-form-group id="fieldset-1" :label="email" label-for="input-1">
        <b-form-input
          id="input-1"
          v-model="credentials.Email"
          :placeholder="emailPlaceholder"
          v-on:blur="showEmailAlertBlur"
          v-on:input="disableEmailAlertBlur"
          trim
          type="email"
          @keyup.enter="
            () => {
              if (emailState && passwordState) {
                handleLogin();
              }
            }
          "
          required
        />
      </b-form-group>
      <b-form-group id="fieldset-2" :label="password" label-for="input-2">
        <div class="password-input-container">
          <b-form-input
            id="input-2"
            v-model="credentials.Password"
            trim
            :type="showPassword ? 'text' : 'password'"
            :placeholder="password"
            @keyup.enter="
              () => {
                if (emailState && passwordState) {
                  handleLogin();
                }
              }
            "
          />
          <div>
            <button
              v-if="showPassword"
              class="btn btn-primary"
              @click="toggleShow"
            >
              <font-awesome-icon :icon="['fas', 'eye-slash']" />
            </button>
            <button v-else class="btn btn-primary" @click="toggleShow">
              <font-awesome-icon :icon="['fas', 'eye']" />
            </button>
          </div>
        </div>
      </b-form-group>
      <div class="login__box__checkbox_link">
        <!--        <b-form-checkbox-->
        <!--          id="checkbox-2"-->
        <!--          v-model="rememberUser"-->
        <!--          name="checkbox-2"-->
        <!--        >-->
        <!--          <span v-html="$t('ManageIdentity.Views.Account.Login.RememberMe')" />-->
        <!--        </b-form-checkbox>-->
        <a href="javascript:void(0)" @click="goToResetPage()">
          <div
            class="links"
            v-html="$t('ManageIdentity.Views.Account.Login.ForgotPassword')"
          />
        </a>
      </div>

      <!-- Login using single sign on sso-->
      <div
        :key="divSsoLogin"
        class="login__box__checkbox_link"
        v-if="ssoLinks"
        v-for="link in ssoLinks"
      >
        <a
          :key="link.name"
          href="javascript:void(0)"
          @click="ssoRoute(link.identityLoginUrl)"
        >
          <div class="links">Login with {{ link.name }}</div>
        </a>
      </div>

      <b-button
        :disabled="!emailState || !passwordState"
        class="login__box__login_btn mb-2"
        variant="primary"
        @click.prevent="handleLogin()"
      >
        <template v-if="loading">
          <span class="login__box__loader" />
        </template>
        <template v-else>
          <span v-html="$t('ManageIdentity.Views.Account.Login.btnLogin')" />
        </template>
      </b-button>

      <br />
      <div>
        <div
          class="login__box__description__two"
          v-html="$t('ManageIdentity.Views.Account.Login.SubHeadline')"
        />
        <router-link :to="goToRoute()">
          <span
            class="links create-account"
            v-html="$t('ManageIdentity.Views.Account.Login.RegisterNewUser')"
          />
        </router-link>
      </div>
      <modal :show="termsModal.show" @close="termsModal.show = false">
        <b-card class="terms-card">
          <div
            class="terms-card__close-button"
            @click.prevent="termsModal.show = false"
          >
            &times;
          </div>
          <b-card-title>
            {{ $t(termsModalTitle) }}
          </b-card-title>
          <b-card-text
            v-html="$t('ManageIdentity.Views.Account.Terms.SubHeadline')"
          />
          <b-tabs card>
            <b-tab :title="termsTitle" active>
              <b-card-text class="modal-text-scroll" v-html="tnc" />
            </b-tab>
            <b-tab :title="dataProtectionTitle">
              <b-card-text class="modal-text-scroll" v-html="data" />
            </b-tab>
            <template v-if="getConfig.context === 'Event'">
              <b-tab :title="termsTitleOrg" v-if="tncOrg">
                <b-card-text class="modal-text-scroll" v-html="tncOrg" />
              </b-tab>
              <b-tab :title="dataProtectionTitleOrg" v-if="dataOrg">
                <b-card-text class="modal-text-scroll" v-html="dataOrg" />
              </b-tab>
            </template>
          </b-tabs>
          <br />
          <b-form-checkbox
            id="checkbox-1"
            v-model="credentials.AcceptTermsOfUse"
            name="checkbox-1"
          >
            <span>{{
              $t("ManageIdentity.Views.Account.Terms.AcceptTerms")
            }}</span>
          </b-form-checkbox>
          <br />
          <br />
          <b-button
            :disabled="!termsState"
            class="login__box__login_btn"
            variant="primary"
            @click.prevent="closeModal()"
          >
            <span v-html="$t('ManageIdentity.Views.Account.Login.btnLogin')" />
          </b-button>
        </b-card>
      </modal>
      <modal :show="transferModal.show" @close="transferModal.show = false">
        <transfer-user :user-data="transferData" />
      </modal>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import accountPageMixins from "../../mixins/accountPageMixins";
import utils from "../../utilities/utils";
import userState from "../../states/user";
import TransferUser from "../../components/TransferUser.vue";
import * as constants from "../../constants/constants";
import base from "~/api/base";

export default {
  created() {
    const user = userState.getUser(this.getConfig.instance);
    const tokenValidUntil = user?.validUntil;
    const queries = this.$route.query;
    if (tokenValidUntil && tokenValidUntil < new Date().getTime()) {
      userState.unsetUser(this.getConfig.instance);
    } else if (tokenValidUntil && tokenValidUntil > new Date().getTime()) {
      this.loginUser(user.accessToken, true);
    } else if (queries.jwt_token) {
      this.loginUser(queries.jwt_token, false, "/");
    } else if (queries.accessToken) {
      const returnUrl = queries.returnUrl ? queries.returnUrl : "/";
      this.loginUser(queries.accessToken, false, returnUrl);
    }
  },
  async mounted() {
    await this.loadTermsAndConditions();
    await this.ssoLoadConfiguration();
  },
  data() {
    return {
      credentials: {
        Email: this.$cookies.get("login_email")
          ? this.$cookies.get("login_email")
          : "",
        Password: this.$cookies.get("login_password")
          ? this.$cookies.get("login_password")
          : "",
        AcceptTermsOfUse: false,
        RememberMe: !!(
          this.$cookies.get("login_email") ||
          this.$cookies.get("login_password")
        ),
        returnUrl: this.returnUrl,
      },
      rememberUser: !!(
        this.$cookies.get("login_email") || this.$cookies.get("login_password")
      ),
      dismissSecs: 60,
      dismissCountDownInvalid: 0,
      dismissCountDownLockout: 0,
      dismissCountDownInvalidLogin: 0,
      transferData: null,
      loading: false,
      showPassword: false,        
      showEmailAlert: false
    }
  },
  props: {
    propHostUrl: {
      type: String,
      default: "",
    },
    returnUrl: {
      type: String,
      default: "",
    },
    returnWithToken: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    TransferUser,
  },
  mixins: [accountPageMixins],
  computed: {
    ...mapGetters({
      getConfig: "ModuleConfig/moduleConfig",
    }),
    emailState() {
      return this.credentials.Email && this.emailValidation;
    },
    passwordState() {
      return this.credentials.Password.length > 0;
    },
    termsState() {
      return this.credentials.AcceptTermsOfUse;
    },
    email() {
      return this.$t("ManageIdentity.Views.Account.Login.Email");
    },
    password() {
      return this.$t("ManageIdentity.Views.Account.Login.Password");
    },
    emailPlaceholder() {
      return this.$t("ManageIdentity.Views.Account.Login.Email");
    },
    termsModalTitle() {
      return this.$t("ManageIdentity.Views.Account.Terms.Headline");
    },
    termsTitle() {
      return this.$t("ManageIdentity.Views.Account.Terms.TermsHeadline");
    },
    dataProtectionTitle() {
      return this.$t("ManageIdentity.Views.Account.Terms.DataHeadline");
    },
    termsTitleOrg() {
      return this.$t('ManageIdentity.Views.Account.Register.TermsCustom')
    },
    dataProtectionTitleOrg() {
      return this.$t('ManageIdentity.Views.Account.Register.DataCustom')
    },
    industryDefaultConfig() {
      return this.configForKey("industry_config");
    },
    emailValidation() {
      return constants.emailRegex.test(this.credentials.Email);
    },
    ssoLinks() {
      return this.$store.getters["singleSignOn/ssoLinks"];
    },
  },
  methods: {
    goToRoute() {
      const route = {
        name: "CreateAccountPage",
        // params: {
        //   instance: this.instance,
        //   event: this.event,
        //   language: this.language,
        // },
      };
      utils.appendDefaultParamsToRoute(route);
      return route;
    },
    showEmailAlertBlur() {
      this.showEmailAlert = true
    },
    disableEmailAlertBlur() {
      this.showEmailAlert = false
    },
    showEmailAlertBlur() {
      this.showEmailAlert = true
    },
    disableEmailAlertBlur() {
      this.showEmailAlert = false
    },
    async handleLogin() {
      this.loading = true;
      if (this.rememberUser) {
        this.$cookies.set("login_email", this.credentials.Email);
        this.$cookies.set("login_password", this.credentials.Password);
      } else {
        this.$cookies.remove("login_email");
        this.$cookies.remove("login_password");
      }
      this.dismissCountDownLockout = 0;
      this.dismissCountDownInvalid = 0;
      this.dismissCountDownLockout = 0;
      this.dismissCountDownInvalidLogin = 0;
      setTimeout(() => {
        this.loading = false;
      }, 30000);
      await this.login(this.credentials).then((res) => {
        if (res.status === 404 || res.status === 400)
          this.showInvalidAlert(res.status);
        if (res === 401 || res.status === 401) this.showInvalidLoginAlert();
        if (res === "Lockout") this.showLockoutAlert();
        if (res === "Unconfirmed")
          this.goToConfirmPage({ email: this.credentials.Email });
        if (res === "Terms") this.openModal(res);
        if (res.token)
          this.loginUser(
            res.token,
            false,
            res.redirectUrl,
            0,
            this.returnWithToken
          );
        if (res.manageTransferNeeded) this.transferUser(res);
        this.loading = false;
      });
    },
    closeModal() {
      this.termsModal.show = false;
      this.handleLogin();
    },
    async openModal(params) {
      this.termsModal.show = true;
      if (params) {
        this.loadTermsAndConditions();
        this.credentials.AcceptTermsOfUse = false;
      }
    },
    transferUser(params) {
      this.transferData = params;
      this.transferModal.show = true;
    },
    countDownChangedInvalid(dismissCountDown) {
      this.dismissCountDownInvalid = dismissCountDown;
    },
    countDownChangedLockout(dismissCountDown) {
      this.dismissCountDownLockout = dismissCountDown;
    },
    countDownChangedInvalidLogin(dismissCountDown) {
      this.dismissCountDownInvalidLogin = dismissCountDown;
    },
    showInvalidLoginAlert() {
      this.dismissCountDownInvalidLogin = this.dismissSecs;
    },
    showLockoutAlert() {
      this.dismissCountDownLockout = this.dismissSecs;
    },
    showInvalidAlert(params) {
      if (params === 404) this.alertData = this.invalidText;
      if (params === 400) this.alertData = this.badrequestText;
      this.dismissCountDownInvalid = this.dismissSecs;
    },
    toggleShow() {
      this.showPassword = !this.showPassword;
    },
    ssoRoute(link) {
      this.loading = true;
      // const host = location.origin;dxc
      const hostUrl =
        this.$store.getters["ModuleConfig/moduleConfig"]?.hostUrl || "";
      // Requires the host_url attribute to have a leading / and no trailing slash
      // TODO is there a URL/URI wrapper class we can use to construct the URL and will handle the / topic for us?
      const returnUrlParam = this.propHostUrl
        ? `&returnUrl=${location.origin}${this.propHostUrl}/auth/correlate`
        : `&returnUrl=${location.origin}${hostUrl}/auth/correlate`;

      console.log("-> hostUrl: " + hostUrl);
      console.log("-> prophostUrl: " + this.propHostUrl);
      console.log("-> returnUrlParam: " + returnUrlParam);
      console.log("-> navigating to -> " + link + returnUrlParam);
      window.location.href = link + returnUrlParam;
    },
    toggleShow() {
      this.showPassword = !this.showPassword
    },
  },
};
</script>

<style lang="scss" scoped>
.links {
  font-weight: 700;
}

.login-container {
  display: flex;
  justify-content: center;

  .login__box {
    display: flex;
    justify-content: center;
    flex-direction: column;

    .login__box__login_btn {
      max-width: 200px;
      cursor: pointer;
    }

    .login__box__login_btn:disabled {
      background-color: rgb(37, 37, 37);
      border-color: rgb(80, 80, 80);
      max-width: 200px;
    }

    .login__box__header,
    .login__box__description {
      align-self: center;
    }

    .login__box__description__two {
      /* display: flex; */ /* not wanted on association.landing.page */
    }

    .login__box__checkbox_link {
      display: flex;
      justify-content: flex-end;
    }
  }

  .links.create-account {
    font-size: 1.2rem;
  }
}

@media (max-width: 668px) {
  .login__box__checkbox_link {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
}

.auth__content {
  width: 100vw;
  max-width: 800px;
  margin-top: 10px;
  padding: 15px;
}

.terms-card {
  border-radius: 10px;
}

.modal-text-scroll {
  overflow-y: scroll;
  height: 100vh;
  max-height: 45vh;
}
.terms-card__close-button {
  float: right;
  font-size: 2rem;
  margin-top: -20px;
  cursor: pointer;
}
.login__box__loader {
  width: 16px;
  height: 16px;
  border: 2px solid #fff;
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
<style lang="scss">
  .password-input-container {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    input {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      border-right: none;
    }
    .btn {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      svg{
        fill: #fff;
        width: .875rem;
      }
    }
  }
</style>